var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurbsideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.38 0.61 84.43 81.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bluedot_Icon_Curbside_090320") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-MVP-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-screen/Alert-on-Customer-Arrival-Copy-3",
    transform: "translate(-466.000000, -452.000000)",
    stroke: "#5AB75F",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bluedot_Icon_Curbside_090320",
    transform: "translate(467.880000, 454.114759)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.18204423,
    y1: 28.0818526,
    x2: 32.9236392,
    y2: 28.0818526,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.2379993,
    y1: 40.431762,
    x2: 39.1056834,
    y2: 40.431762,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 52.7816715,
    x2: 32.9236392,
    y2: 52.7816715,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.2640745 61.5726518 64.7413164 78.4456624 81.43 21.8430923 34.9512363 6.30290776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7765227,10.2730279 L48.0951698,6.31708676 C49.7244741,1.4770299 54.9605071,-1.13464761 59.8070242,0.475338549 L65.0532544,2.23353461 C67.3789556,3.0095665 69.3003711,4.67897374 70.3936369,6.8734854 C71.4869027,9.06799705 71.6621875,11.6072948 70.8808236,13.93121 L69.5621766,17.8871512",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "62.2032753 15.4200051 57.5525631 29.3437836 70.2569476 33.5974838 74.9218388 19.6737053"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurbsideIcon);
export default __webpack_public_path__ + "static/media/CurbsideIcon.6a96aae11a073abee63f27b017143c7e.svg";
export { ForwardRef as ReactComponent };